<template>
    <header class="header">
            <div class="header_left">
                <img  class="logo" src="../../assets/main_logo.png" alt="">
                <span>Replenishment Simulation Tool</span>
            </div>
            <div class="header_right">
                <div class="header_user" v-on:click="changeShowUser()">
                    <img class="user_logo" src="../../assets/header_logo.png" alt="">
                    <span>{{userName}}</span>
                    <div v-if="ifshowUser" class="user_panel" v-on:click="toUserPage()">
                        <img class="header_bg" src="../../assets/tip_icon.png" alt="">
                        <span class="user">用户管理</span>
                    </div>
                </div>
                
                
                <div v-on:click="userLogOut()" class="btn">
                    <img src="../../assets/logout.png" alt="">
                </div>
            </div>
        </header>
</template>
<script>
import {logOut} from "../../util/api.js";
export default {
  name: "PageHeader",
  data() {
    return {
        ifshowUser:false,
        userName:'',
        ifAdmin:false,
    };
  },
  mounted: function(){
      this.userName = this.getCookie('rstuserName');
      this.ifAdmin = this.getCookie('authority') && this.getCookie('authority') == 'ROLE_ADMIN'? true: false;
  },
  methods: {
      getCookie: function(name) {
        var arr;
        var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
        else return null;
      },
      changeShowUser:function(){
          if(this.ifAdmin){
              this.ifshowUser = !this.ifshowUser;
          }
      },
      toUserPage:function(){
          this.$router.push('/user');
      },
      userLogOut:function(){
          let that = this;
          logOut()
            .then(function(){
                localStorage.removeItem('userId');
                localStorage.removeItem('userName');
                localStorage.removeItem('authority');
                that.$router.push('/login');
            })
            .catch(function(error){
                localStorage.removeItem('userId');
                localStorage.removeItem('userName');
                localStorage.removeItem('authority');
                that.$router.push('/login');
            })
      }
  }
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 0.36rem;
  line-height: 0.36rem;
  background-color: #262626;
  padding: 0 0.31rem 0 0.29rem;
  overflow: hidden;
  color: #fff;
}
.header img {
  vertical-align: middle;
}
.header_left {
  float: left;
  font-size: 0.15rem;
}
.header_left .logo{
    width: 0.36rem;
}
.header_right {
  float: right;
  display: flex;
}
.header_right .btn img{
    width: 0.16rem;
}
.header_user {
  padding-right: 0.21rem;
  cursor: pointer;
}
.user_panel {
  position: absolute;
  right: 0.31rem;
  cursor: pointer;
}
.user_panel .user {
  position: absolute;
  top: 0;
  padding-top: 0.1rem;
  width: 1.37rem;
  left: 0;
  text-align: center;
}
.header_bg{
    width: 1.37rem;
}
.btn{
    cursor: pointer;
}
.user_logo{
    width: 0.2rem;
}
</style>




// WEBPACK FOOTER //
// src/components/common/PageHeader.vue